export const tickets = {
  title: 'Tickets',
  icon: 'mdi-inbox-multiple',
  callbackName: '__refreshTickets',
  refresh: 'tickets',
  disabled: 'tickets',
  children: []
}
